// extracted by mini-css-extract-plugin
export default {"light":"light--Eh7+i+9UOV"};